import { Component, Input, OnInit } from '@angular/core';

import { INivelesPromo } from '../../../../private/shared/models/productos';

@Component({
  selector: 'app-header-level',
  templateUrl: './header-level.component.html',
  styleUrls: ['./header-level.component.scss'],
})
export class HeaderLevelComponent implements OnInit {

  @Input() NivelesPromo: INivelesPromo[] = [];
  @Input() levelStairs = 0;

  constructor() { }

  ngOnInit() { }

  public onChangeSegment = (event: Event) => {
    const content = document.getElementById(`segment`) as HTMLElement;
    const level = event['detail'].value;
    const segment = document.getElementById(`segment-${level}`)?.offsetWidth as number;
    const scrollLeft = content.scrollLeft;

    if (scrollLeft > 0 && level < this.NivelesPromo.length) {
      content.scrollTo(scrollLeft - (segment * level), 0);
    } else if (level > 1 && scrollLeft < 1) {
      content.scrollTo(scrollLeft + (segment * level), 0);
    }
  }

}
